import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@circuitry-ai/doc-data';
import { AgentChatOptionsWithErrorBoundary } from './agent-chat-options';

// Unified feedback component that handles both claim data and action data
const FeedbackComponent = ({
  data,
  dataType = 'claim',
  showRerun = false // Default to false for non-execute contexts
}: {
  data: any,
  dataType?: 'claim' | 'action',
  showRerun?: boolean
}) => {
  const { agentMessageState } = useSelector((state: RootState) => state.chatAdvisorSliceReducer);

  // Handle both claim data (array) and action data (object)
  const itemData = dataType === 'claim' ? data?.[0] : data;

  if (!itemData) return null;

  const messageId = itemData.message_id || itemData.aiworker_usage_id;
  const agentState = agentMessageState?.[messageId];

  // Extract message content based on data type
  const messageContent = dataType === 'claim'
    ? (itemData.ai_summary || itemData.title || '')
    : (itemData.ai_summary || itemData.agent_name || '');

  return (
    <AgentChatOptionsWithErrorBoundary
      message={{
        messageId: messageId,
        message: messageContent,
        metaData: [],
        feedback_history: agentState?.feedback ? [{
          feedback_type: agentState.feedback
        }] : (itemData.feedback_history || []),
        comment_history: agentState?.comments || (itemData.comment_history || []),
        comment: ''
      }}
      aiworker_id={itemData.aiworker_id}
      session_id={itemData.aiworker_usage_id}
      msgIndex={0} // Default index for feedback contexts
      showRerun={showRerun}
    />
  );
};

export { FeedbackComponent };
